import { Pipe, PipeTransform } from '@angular/core';
import { OrderData } from '@zero/shared/util-models';

@Pipe({
  name: 'orderLimitStopOrUndefined',
  pure: false,
  standalone: true,
})
export class OrderLimitStopOrUndefinedPipe implements PipeTransform {
  public transform(order?: OrderData): number | undefined {
    if (!order) {
      return undefined;
    }

    const { execType, limitPrice, stopPrice } = order;
    switch (execType) {
      case 'market':
      case 'fraction':
        return undefined;
      case 'limit':
        return limitPrice;
      default:
        return stopPrice;
    }
  }
}
